import React, { useEffect, useState } from "react";
import {
  Container, Card, CardBody, CardHeader, Button, Modal, ModalHeader, ModalBody,
  ModalFooter, Input, Label, Row, Col, Badge, Spinner,
} from "reactstrap";
import api from "./api";
import { aviso } from '../../../lib/dialogo';

const STATUS = { aberto: "warning", andamento: "info", resolvido: "success", fechado: "secondary" };
const PRIO = { alta: "danger", media: "warning", baixa: "secondary" };
const dataBR = (d) => (d ? new Date(d).toLocaleString("pt-BR") : "");

const HelpDesk = () => {
  const [lista, setLista] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [novo, setNovo] = useState(false);
  const [form, setForm] = useState({ cliente_id: "", assunto: "", descricao: "", prioridade: "media" });
  const [aberto, setAberto] = useState(null); // ticket detalhado
  const [msg, setMsg] = useState("");
  const [erro, setErro] = useState("");

  const carregar = async () => {
    setLoading(true);
    try {
      const [t, c] = await Promise.all([api.get("/oplena/tickets"), api.get("/oplena/clientes")]);
      setLista(t || []); setClientes(c || []);
    } catch (e) { setErro(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { carregar(); }, []);

  const criar = async () => {
    if (!form.assunto.trim()) { setErro("Informe o assunto."); return; }
    setErro("");
    try {
      await api.post("/oplena/tickets", { ...form, cliente_id: form.cliente_id || null });
      setNovo(false); setForm({ cliente_id: "", assunto: "", descricao: "", prioridade: "media" });
      await carregar();
    } catch (e) { setErro(e.message); }
  };

  const abrir = async (t) => {
    try { setAberto(await api.get(`/oplena/tickets/${t.id}`)); } catch (e) { aviso(e.message, 'error'); }
  };

  const responder = async () => {
    if (!msg.trim()) return;
    try {
      await api.post(`/oplena/tickets/${aberto.id}/mensagens`, { mensagem: msg, autor: "suporte" });
      setMsg(""); await abrir(aberto);
    } catch (e) { aviso(e.message, 'error'); }
  };

  const mudarStatus = async (status) => {
    try { await api.put(`/oplena/tickets/${aberto.id}`, { ...aberto, status }); setAberto({ ...aberto, status }); await carregar(); }
    catch (e) { aviso(e.message, 'error'); }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <Card>
          <CardHeader className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <div><h4 className="mb-0 fw-bold">Help Desk</h4><small className="text-muted">{lista.length} chamado(s)</small></div>
            <Button color="primary" onClick={() => { setErro(""); setNovo(true); }}><i className="fa-solid fa-plus me-1" /> Novo chamado</Button>
          </CardHeader>
          <CardBody>
            {loading ? (
              <div className="text-center py-5"><Spinner /></div>
            ) : lista.length === 0 ? (
              <div className="text-center text-muted py-5">Nenhum chamado.</div>
            ) : (
              <div className="d-flex flex-column gap-2">
                {lista.map((t) => (
                  <div key={t.id} role="button" onClick={() => abrir(t)}
                    className="d-flex align-items-center justify-content-between p-3 rounded"
                    style={{ background: "var(--iev-surface)", border: "1px solid var(--iev-border)" }}>
                    <div className="d-flex align-items-center gap-3">
                      <Badge color={PRIO[t.prioridade] || "secondary"} pill>{t.prioridade}</Badge>
                      <div>
                        <div className="fw-semibold">{t.assunto}</div>
                        <small className="text-muted">{t.cliente_nome || "Sem cliente"} · {dataBR(t.created_at)}</small>
                      </div>
                    </div>
                    <Badge color={STATUS[t.status] || "secondary"}>{t.status}</Badge>
                  </div>
                ))}
              </div>
            )}
          </CardBody>
        </Card>

        {/* Novo chamado */}
        <Modal isOpen={novo} toggle={() => setNovo(false)} centered>
          <ModalHeader toggle={() => setNovo(false)}>Novo chamado</ModalHeader>
          <ModalBody>
            {erro && <div className="alert alert-danger py-2">{erro}</div>}
            <Row className="g-3">
              <Col md={12}><Label>Assunto *</Label><Input value={form.assunto} onChange={(e) => setForm({ ...form, assunto: e.target.value })} /></Col>
              <Col md={6}><Label>Cliente</Label>
                <Input type="select" value={form.cliente_id} onChange={(e) => setForm({ ...form, cliente_id: e.target.value })}>
                  <option value="">— sem cliente —</option>
                  {clientes.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
                </Input>
              </Col>
              <Col md={6}><Label>Prioridade</Label>
                <Input type="select" value={form.prioridade} onChange={(e) => setForm({ ...form, prioridade: e.target.value })}>
                  {Object.keys(PRIO).map((p) => <option key={p} value={p}>{p}</option>)}
                </Input>
              </Col>
              <Col md={12}><Label>Descrição</Label><Input type="textarea" rows={3} value={form.descricao} onChange={(e) => setForm({ ...form, descricao: e.target.value })} /></Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="light" onClick={() => setNovo(false)}>Cancelar</Button>
            <Button color="primary" onClick={criar}>Abrir chamado</Button>
          </ModalFooter>
        </Modal>

        {/* Detalhe do ticket */}
        <Modal isOpen={!!aberto} toggle={() => setAberto(null)} centered size="lg">
          {aberto && (
            <>
              <ModalHeader toggle={() => setAberto(null)}>
                {aberto.assunto} <Badge color={STATUS[aberto.status]} className="ms-2">{aberto.status}</Badge>
              </ModalHeader>
              <ModalBody>
                <p className="text-muted">{aberto.cliente_nome || "Sem cliente"} · {dataBR(aberto.created_at)}</p>
                {aberto.descricao && <p>{aberto.descricao}</p>}
                <div className="d-flex flex-column gap-2 my-3" style={{ maxHeight: 280, overflowY: "auto" }}>
                  {(aberto.mensagens || []).map((m) => (
                    <div key={m.id} className="p-2 rounded" style={{ background: m.autor === "suporte" ? "var(--iev-gold-15)" : "var(--iev-surface)", border: "1px solid var(--iev-border)" }}>
                      <small className="text-muted d-block mb-1">{m.autor} · {dataBR(m.created_at)}</small>
                      {m.mensagem}
                    </div>
                  ))}
                  {(!aberto.mensagens || aberto.mensagens.length === 0) && <small className="text-muted">Sem mensagens ainda.</small>}
                </div>
                <Input type="textarea" rows={2} placeholder="Responder..." value={msg} onChange={(e) => setMsg(e.target.value)} />
              </ModalBody>
              <ModalFooter className="justify-content-between">
                <Input type="select" style={{ maxWidth: 180 }} value={aberto.status} onChange={(e) => mudarStatus(e.target.value)}>
                  {Object.keys(STATUS).map((s) => <option key={s} value={s}>{s}</option>)}
                </Input>
                <Button color="primary" onClick={responder}>Enviar resposta</Button>
              </ModalFooter>
            </>
          )}
        </Modal>
      </Container>
    </div>
  );
};

export default HelpDesk;
